/**
 * Implements a DEX score tab
 */
import { ITokenScore } from '@kattana-io/common';
import CoinInfoField from '../CoinInfoField';

const decorateKey = (key: string): string => {
  switch (key) {
  case 'coingecko':
    return 'Coingecko';
  case 'dex_networks':
    return 'More than 1 network';
  case 'holders':
    return 'More than 100 holders';
  case 'liquidity':
    return 'More than 100000$ liquidity';
  case 'pairs':
    return 'More than 1 pair';
  case 'proxy':
    return 'Is proxy contract';
  default:
    return key[0].toUpperCase() + key.slice(1);
  }
};

interface IDexCoinScoreProps {
  scoreData: ITokenScore | null;
}

const DexCoinScore = ({ scoreData }: IDexCoinScoreProps) => {
  if (!scoreData) {
    return null;
  }

  const { points, ...rest } = scoreData;

  return (
    <>
      {Object.keys(rest)
        .sort()
        .map((key) => (
          <CoinInfoField
            key={key}
            name={decorateKey(key)}
            value={rest[key as keyof typeof rest]}
          />
        ))}
    </>
  );
};

export default DexCoinScore;
